import { Link } from 'react-router-dom'
import type { UserEventDashboard } from '@fellowship/shared'
import { useIsMobile } from '../../../hooks/useIsMobile'
import { EYEBROW_STYLE } from '../format'
import { FollowedChurchCard } from '../FollowedChurchCard'

export function FollowingTab({ dashboard }: { dashboard: UserEventDashboard }) {
  const isMobile = useIsMobile()
  const { followedChurches } = dashboard

  return (
    <div>
      <div style={{ ...EYEBROW_STYLE, marginBottom: 14 }}>
        Churches you follow · {followedChurches.length}
      </div>

      {followedChurches.length === 0 ? (
        <div
          style={{
            padding: 32,
            background: 'var(--surface)',
            border: '1px solid var(--line-soft)',
            borderRadius: 16,
            textAlign: 'center',
            maxWidth: 760,
          }}
        >
          <p style={{ margin: '0 0 6px', fontSize: 15, fontWeight: 600, color: 'var(--ink)' }}>
            You&rsquo;re not following any churches yet.
          </p>
          <p style={{ margin: '0 0 14px', fontSize: 13, color: 'var(--muted)' }}>
            Follow churches to see their events and get notified about what&rsquo;s new.
          </p>
          <Link to="/churches" style={{ fontSize: 13, color: 'var(--primary)', fontWeight: 600, textDecoration: 'none' }}>
            Discover churches near you →
          </Link>
        </div>
      ) : (
        <>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
              gap: 14,
              maxWidth: 760,
            }}
          >
            {followedChurches.map((church) => (
              <FollowedChurchCard key={church.id} church={church} />
            ))}
          </div>
          <Link
            to="/churches"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 6,
              marginTop: 18,
              fontSize: 13.5,
              fontWeight: 600,
              color: 'var(--primary)',
              textDecoration: 'none',
            }}
          >
            Discover more churches near you →
          </Link>
        </>
      )}
    </div>
  )
}
